export const BUTTON_TYPES = {
    EMAIL: 'email',
    PHONE: 'phone',
    EMAIL_AND_PHONE: 'email_and_phone',
    NONE: '',
};
